import { X_COUNTRY_CODE, X_REGION_CODE } from '@/constants/headers';
import {
  PLA_COUNTRY_CODE_PARAM_KEY,
  PLA_COUNTRY_CODE_PARAM_VALUES,
  PLA_US_FEED_PARAM_KEY,
  PLA_US_FEED_PARAM_REGION_ID,
  PLA_US_FEED_PARAM_VALUE,
  PLA_US_INCLUSIVE_PRICING_REGION_ID_PARAM_VALUE,
  PLA_US_REGION_ID_PARAM_KEY,
  PLA_US_REGION_ID_PARAM_VALUE,
  REGION_ID_TO_X_REGION_CODE,
} from '@/modules/experiments/constants';

export function getPlaCountryCodeFromQueryParams(
  countryCodeParam?: string,
  plaFeedParam?: string
) {
  const plaCountryCode = (() => {
    const param = countryCodeParam?.trim().toLowerCase();
    if (param) {
      return PLA_COUNTRY_CODE_PARAM_VALUES.includes(param) ? param : undefined;
    } else if (plaFeedParam?.trim().toLowerCase() === PLA_US_FEED_PARAM_VALUE) {
      return PLA_US_FEED_PARAM_VALUE;
    }
  })();
  return plaCountryCode;
}

export function getPlaRegionCodeFromQueryParams(
  regionIdParam?: string,
  plaFeedParam?: string
) {
  const regionCode = (() => {
    if (regionIdParam?.trim().toLowerCase() === PLA_US_REGION_ID_PARAM_VALUE) {
      return REGION_ID_TO_X_REGION_CODE.upfront_fees;
    } else if (
      regionIdParam?.trim().toLowerCase() ===
      PLA_US_INCLUSIVE_PRICING_REGION_ID_PARAM_VALUE
    ) {
      return REGION_ID_TO_X_REGION_CODE.inclusive_pricing;
    } else if (plaFeedParam?.trim().toLowerCase() === PLA_US_FEED_PARAM_VALUE) {
      return REGION_ID_TO_X_REGION_CODE[PLA_US_FEED_PARAM_REGION_ID];
    }
  })();
  return regionCode;
}

export function getPlaHeaders({
  queryParams,
}: {
  queryParams?: Record<string, string>;
}) {
  if (queryParams) {
    const plaCountry = queryParams[PLA_COUNTRY_CODE_PARAM_KEY];
    const plaUSFeed = queryParams[PLA_US_FEED_PARAM_KEY];
    const regionCode = queryParams[PLA_US_REGION_ID_PARAM_KEY];

    const plaCountryCode = getPlaCountryCodeFromQueryParams(
      plaCountry,
      plaUSFeed
    );
    const plaRegionCode = getPlaRegionCodeFromQueryParams(
      regionCode,
      plaUSFeed
    );

    const headers = {
      ...(plaCountryCode && { [X_COUNTRY_CODE]: plaCountryCode }),
      ...(plaRegionCode && { [X_REGION_CODE]: plaRegionCode }),
    };

    return headers;
  }
}
